/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type { ListHomepageRecentsQueryResponse } from '../../types/ListHomepageRecents'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listHomepageRecents } from '../../clients/listHomepageRecents'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listHomepageRecentsQueryKey = () =>
  [{ url: '/api/v1/homepage/recents/' }] as const

export type ListHomepageRecentsQueryKey = ReturnType<
  typeof listHomepageRecentsQueryKey
>

export function listHomepageRecentsQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listHomepageRecentsQueryKey()
  return queryOptions<
    ListHomepageRecentsQueryResponse,
    ResponseErrorConfig<Error>,
    ListHomepageRecentsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listHomepageRecents({ ...config, signal: config.signal ?? signal })
    },
  })
}

/**
 * @summary List the current user's recently visited items
 * {@link /api/v1/homepage/recents/}
 */
export function useListHomepageRecents<
  TData = ListHomepageRecentsQueryResponse,
  TQueryData = ListHomepageRecentsQueryResponse,
  TQueryKey extends QueryKey = ListHomepageRecentsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListHomepageRecentsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? listHomepageRecentsQueryKey()

  const query = useQuery(
    {
      ...listHomepageRecentsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
